import { motion } from "framer-motion";

import { useNavigate } from "react-router-dom";

import { NavGroupData, NavSubItemData } from "../const";

import { NavItemWrapper, NavTextWrapper } from "../styles";
import { useLegacyEffect } from "helper/customHook";
import { getPermissionItemStart } from "../redux/roleItem";
import { useDispatch } from "react-redux";
import { isArray } from "lodash";

type NavSubItemProps = {
  navGroupData: NavGroupData;
  navSubItem: NavSubItemData;
  isMiniSidenav: boolean;
  isActiveGroup: boolean;
  isActive: boolean;
};

function NavSubItem({
  navSubItem,
  isMiniSidenav,
  isActiveGroup,
  isActive,
}: NavSubItemProps) {
  const dispatch = useDispatch();

  const { subLabel, path, screenKey } = navSubItem;

  const navigate = useNavigate();

  const handleActiveSidenav = () => {
    navigate(path);
  };

  useLegacyEffect(() => {
    if (isActive && path) {
      if (!screenKey || isArray(screenKey)) return;
      dispatch(getPermissionItemStart(screenKey));
    }
  }, [isActive, path, screenKey]);

  return (
    <NavItemWrapper
      isActiveGroup={isActiveGroup}
      isActive={isActive}
      onClick={handleActiveSidenav}
    >
      {!isMiniSidenav ? (
        <motion.div
          key="nav-text"
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -10 }}
          transition={{
            exit: { duration: 0.3, delay: 0.3 },
            animate: { duration: 0.1, delay: 0.3 },
          }}
          // style={{ whiteSpace: "nowrap" }}
        >
          <NavTextWrapper> {subLabel}</NavTextWrapper>{" "}
        </motion.div>
      ) : (
        <NavTextWrapper>-</NavTextWrapper>
      )}
    </NavItemWrapper>
  );
}

export default NavSubItem;
